import { RouteType } from "types/RouteType";
import AddRawMaterialsWizardStore from "./AddRawMaterialsWizardStore";

const AddRawMaterialsWizardRoute: RouteType = {
  name: "AddRawMaterialsWizard",
  path: "/workflows/add-raw-materials",
  layout: "/app",
  group: "Workflows",
  requiresAuth: true,
  requiresPermission: false,
  viewportCard: {
    header: {
      title: "Add Raw Materials",
      component: () => import("./AddRawMaterialsWizardHeader"),
      enableRefreshButton: true,
      enableBackButton: true,
    },
    body: {
      component: () => import("./AddRawMaterialsWizard"),
      grayBackground: true,
    },
  },
  beforeEnter: async ({ rootStore }) => {
    if (!rootStore.addRawMaterialsWizardStore) {
      rootStore.addRawMaterialsWizardStore = new AddRawMaterialsWizardStore(
        rootStore
      );
    }
    await rootStore.addRawMaterialsWizardStore.loadInitialData();
    return true;
  },
};

export default AddRawMaterialsWizardRoute;
